import { useCallback, useState } from 'react';

import ConfirmationDialog from '@sayyesschool/frontend/components/confirmation-dialog';
import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import PageSection from '@sayyesschool/frontend/components/page-section';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import UnitForm from '../unit-form';
import UnitsList from '../units-list';

export default function CourseUnits({ course, onCreate, onDelete }) {
    const [unit, setUnit] = useState();
    const [isFormDialogOpen, toggleFormDialogOpen] = useBoolean(false);
    const [isConfirmationDialogOpen, toggleConfirmationDialogOpen] = useBoolean(false);

    const handleCreate = useCallback(data => {
        return onCreate(data).finally(() => toggleFormDialogOpen(false));
    }, [onCreate, toggleFormDialogOpen]);

    const handleDelete = useCallback(() => {
        return onDelete(unit).finally(() => {
            toggleConfirmationDialogOpen(false);
            setUnit(undefined);
        });
    }, [unit, onDelete, toggleConfirmationDialogOpen]);

    const handleDeleteRequest = useCallback(unit => {
        setUnit(unit);
        toggleConfirmationDialogOpen(true);
    }, [toggleConfirmationDialogOpen]);

    return (
        <PageSection
            className="CourseUnits"
            title="Юниты"
            actions={[{
                key: 'add',
                icon: 'add',
                title: 'Добавить юнит',
                onClick: toggleFormDialogOpen
            }]}
            compact
        >
            <UnitsList
                units={course.units}
                onDelete={handleDeleteRequest}
            />

            <FormDialog
                title="Новый юнит"
                open={isFormDialogOpen}
                onClose={toggleFormDialogOpen}
            >
                <UnitForm
                    id="unit-form"
                    onSubmit={handleCreate}
                />
            </FormDialog>

            <ConfirmationDialog
                title="Удалить юнит?"
                message={unit && `Юнит "${unit.title}" будет удален без возможности восстановления.`}
                open={isConfirmationDialogOpen}
                onConfirm={handleDelete}
                onClose={toggleConfirmationDialogOpen}
            />
        </PageSection>
    );
}